import { inject, Injectable } from '@angular/core';
import { CampaignsService } from '@buck-e-icp/interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';

import { StoreDataActions } from './store-data.actions';

@Injectable()
export class StoreDataEffects {
    private actions = inject(Actions);
    private campaignsService = inject(CampaignsService);

    loadCampaigns$ = createEffect(() =>
        this.actions.pipe(
            ofType(StoreDataActions.loadCampaigns),
            exhaustMap(({ onlyActive }) =>
                this.campaignsService.listCampaigns(onlyActive ?? true).pipe(
                    map((campaignList) => StoreDataActions.loadCampaignsSuccess({ payload: campaignList })),
                    catchError((err) => of(StoreDataActions.loadCampaignsFailure(err))),
                ),
            ),
        ),
    );
}
